import { HttpHeaders } from '@angular/common/http';
import { AfterViewChecked, Component, OnInit } from '@angular/core';
import { AirlineOffersScreenRequest } from 'src/app/model/request/airline-offers-screen-request';
import { FindOrderScreenRequest } from 'src/app/model/request/find-order-screen-request';
import { OfferPriceScreenOrderCreateRequest } from 'src/app/model/request/offer-price-screen-order-create-request';
import { OrderChangeIssueTicketRequest, Passenger as orderChangePassenger } from 'src/app/model/request/order-change-issue-ticket-request';
import { OfferItemID, OfferItemIDAttributes, Passenger as primeSalePassenger, PrimeSaleAddBaggageRequest } from 'src/app/model/request/prime-sale-add-baggae';
import { AddAncilliariesScreen, OfferItem as addAncilliariesOfferItem } from 'src/app/model/screen/add-ancilliaries-screen';
import { AddBaggageScreen } from 'src/app/model/screen/add-baggage-screen';
import { OfferItems } from 'src/app/model/screen/offer-price-screen';
import { Passenger, Passenger as passengerDetailScreenPassenger, Passenger as PassengerScreenPassenger, PassengerDetailScreen } from 'src/app/model/screen/passenger-detail-screen';
import { YourBookingScreen } from 'src/app/model/screen/your-booking-screen';
import { ApiService } from 'src/app/service/api.service';
import { LocalAssetReaderService } from 'src/app/service/local-asset-reader.service';
import { SandboxPageStateService } from 'src/app/service/sandbox-page-state.service';
import { XmlToJsonParserService } from 'src/app/service/xml-to-json-parser.service';
import reQuoteTicketJSON from 'src/assets/json/order-change/request/requote-ticket-default-params.json';

@Component({
  selector: 'app-passenger-details',
  templateUrl: './passenger-details.component.html',
  styleUrls: ['./passenger-details.component.scss']
})
export class PassengerDetailsComponent implements OnInit {
  orderChangeRemoveService: OrderChangeIssueTicketRequest = {} as OrderChangeIssueTicketRequest;
  orderChangeInputParams = new Map();
  constructor(
    private sandboxPageStateService: SandboxPageStateService,
    private apiService: ApiService,
    private localAssetReaderService: LocalAssetReaderService,
    private xmlToJsonParserService: XmlToJsonParserService
  ) {
    Object.entries(reQuoteTicketJSON).forEach((entry) => {
      const [key, value] = entry;
      this.orderChangeInputParams.set(key, value);
    });
  }
  public passengerDetailScreenData = {} as PassengerDetailScreen;
  public show: boolean = false;
  public buttonName: any = 'Show';
  offerPriceScreenServiceListRequest: PrimeSaleAddBaggageRequest = {} as PrimeSaleAddBaggageRequest;
  yourBookingScreen: YourBookingScreen = {} as YourBookingScreen;

  public selectedPassengerIndex: any = '';
  public selectedServiceIndex: any = '';
  public selectedServiceType: any = '';

  isSMEUser: boolean = false;

  ngOnInit(): void {
    this.sandboxPageStateService.sandboxScreenDataSource.subscribe((sandboxScreenData: any) => {
      this.passengerDetailScreenData = sandboxScreenData.passengerDetailScreen;
      let pas = sandboxScreenData;
    });

    this.passengerDetailScreenData.passengerBList = [];
    this.yourBookingScreen = this.sandboxPageStateService.getYourBookingScreenData();
    this.isSMEUser = this.sandboxPageStateService.getUser().isSMEUser;
  }

  getModel() {
    return {
      onColor: 'primary',
      offColor: 'secondary',
      onText: 'B',
      offText: 'A',
      disabled: false,
      value: false
    };
  }
  addAncilliaries() {
    let addAnclilliariesScreenData = this.sandboxPageStateService.getAddAncilliariesScreenData();
    if (typeof addAnclilliariesScreenData === 'undefined') {
      addAnclilliariesScreenData = {} as AddAncilliariesScreen;
      addAnclilliariesScreenData.displayService = 'All';

      addAnclilliariesScreenData.xml = '';
      addAnclilliariesScreenData.json = '';
      this.sandboxPageStateService.updateAddAncilliariesScreenData(addAnclilliariesScreenData);
    }

    if (!addAnclilliariesScreenData.isServiceRequestGenerate) {
      this.initServiceXMLRequest();
    } else {
      let patchSandboxSourceData = { mainMenu: 'add-ancilliaries-screen' };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    }
  }
  async initServiceXMLRequest() {
    let yourBookingScreenData = this.sandboxPageStateService.getYourBookingScreenData();
    let pnr = yourBookingScreenData.booking.pnrNumber;
    let owner = yourBookingScreenData.booking.bookingAgent;
    let carb = 'CARB';
    let includes = 'true';
    let findOrderScreenRequest = {} as FindOrderScreenRequest;
    let createOrderScreenRequest = {} as OfferPriceScreenOrderCreateRequest;
    if (yourBookingScreenData.bookingType === 'pre-booking') {
      let jsonRequest = this.sandboxPageStateService.getJsonRequestFromMap(this.sandboxPageStateService.OFFER_PRICE_SCREEN_ORDER_CREATE_URL);
      createOrderScreenRequest = JSON.parse(jsonRequest);
    } else if (yourBookingScreenData.bookingType === 'post-booking') {
      let jsonRequest = this.sandboxPageStateService.getJsonRequestFromMap(this.sandboxPageStateService.FIND_ORDER_SCREEN_URL);
      findOrderScreenRequest = JSON.parse(jsonRequest);
    }
    let jsonRequestTemplate = await this.localAssetReaderService.getContent(this.sandboxPageStateService.PRIME_BAG_SERVICE_REQUEST_TEMPLATE);
    this.offerPriceScreenServiceListRequest = JSON.parse(jsonRequestTemplate as any);
    this.offerPriceScreenServiceListRequest['S:Envelope'].$!['xmlns:S'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.offerPriceScreenServiceListRequest['S:Envelope'].$!['xmlns:SOAP-ENV'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.offerPriceScreenServiceListRequest['S:Envelope']['SOAP-ENV:Header'] = '';
    this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ.$['xmlns:xsd'] = 'http://www.w3.org/2001/XMLSchema';
    this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ.$['xmlns:xsi'] = 'http://www.w3.org/2001/XMLSchema-instance';
    this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ.$.xmlns = 'http://www.iata.org/IATA/EDIST/2017.2';
    this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ.$.Version = '17.2';
    if (yourBookingScreenData.bookingType === 'pre-booking') {
      this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ.Document = createOrderScreenRequest['S:Envelope']['S:Body']?.OrderCreateRQ.Document;
      this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ.Party = createOrderScreenRequest['S:Envelope']['S:Body']?.OrderCreateRQ.Party;
    } else {
      this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ.Document = findOrderScreenRequest['S:Envelope']['S:Body']?.OrderRetrieveRQ.Document;
      this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ.Party = findOrderScreenRequest['S:Envelope']['S:Body']?.OrderRetrieveRQ.Party;
    }
    delete this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ.ShoppingResponseID;
    delete this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ.Query.Offers;
    this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ.Query.OrderID = {
      $: {
        Owner: owner
      },
      _: pnr
    };
    this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ.DataLists.PassengerList.Passenger = [];
    this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ.DataLists.PassengerList.Passenger = this.loadServicePassenger();
    await this.apiService.getXMLResponse(this.sandboxPageStateService.OFFER_PRICE_SCREEN_SERVICE_LIST_URL, JSON.stringify(this.offerPriceScreenServiceListRequest), new Map(), {
      headers: new HttpHeaders({
        soapAction: 'ServiceList17_2_V1'
      }),
      responseType: 'text'
    });
    this.updateAddAncilliariesResponse(this.sandboxPageStateService.OFFER_PRICE_SCREEN_SERVICE_LIST_URL);
  }
  loadServicePassenger() {
    let passengerScreenDetail = this.sandboxPageStateService.getPassengerScreenDetail();
    let passengerDetail = passengerScreenDetail.passengerDetail;
    let passengerRequestDetails: primeSalePassenger[] = [];
    let passengerDetailLength: any = passengerDetail.length;
    if (passengerDetailLength > 0) {
      passengerDetail.forEach((passenger: PassengerScreenPassenger) => {
        let passengerId = passenger.passengerId;
        let passengerDetail: primeSalePassenger = {
          $: {
            PassengerID: passengerId
          },
          PTC: passenger.passengerType,
          Birthdate: passenger.passengerDOB,
          Individual: {
            Gender: passenger.passengerGender,
            NameTitle: passenger.passengerNameTitle,
            GivenName: passenger.passengerName,
            Surname: passenger.passengerSurName
          }
        };
        if (typeof passenger.infantRef !== 'undefined') {
          passengerDetail.InfantRef = passenger.infantRef;
        }
        passengerRequestDetails.push(passengerDetail);
      });
    }
    return passengerRequestDetails;
  }
  updateAddAncilliariesResponse(url: any) {
    let patchSandboxSourceData: any = '';
    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      patchSandboxSourceData = { showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else if (this.sandboxPageStateService.getWarningMessage() !== '') {
      patchSandboxSourceData = { showWarning: 'Yes', warningMessage: this.sandboxPageStateService.getWarningMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      let addServiceScreenDetail = this.sandboxPageStateService.getAddBaggageScreenDetail();
      addServiceScreenDetail.xml = this.sandboxPageStateService.getResponseFromMap(url);
      addServiceScreenDetail.jsonData = this.xmlToJsonParserService.parseXMLToJSON(addServiceScreenDetail.xml);
      addServiceScreenDetail.bookingType = 'your-booking-screen-add-ancilliaries';
      this.sandboxPageStateService.updateAddBaggageScreenDetail(addServiceScreenDetail);
      let addAnclilliariesScreenData = this.sandboxPageStateService.getAddAncilliariesScreenData();
      addAnclilliariesScreenData.isServiceRequestGenerate = true;
      addAnclilliariesScreenData.displayService = 'All';
      addAnclilliariesScreenData.selectedOfferId = '';
      addAnclilliariesScreenData.selectedOfferItem = [];
      addAnclilliariesScreenData.selectedOwner = '';
      addAnclilliariesScreenData.currency = '';
      addAnclilliariesScreenData.selectedResponseId = '';

      addAnclilliariesScreenData.xml = addServiceScreenDetail.xml;
      addAnclilliariesScreenData.json = addServiceScreenDetail.jsonData;
      this.sandboxPageStateService.updateAddAncilliariesScreenData(addAnclilliariesScreenData);

      let patchSandboxSourceData = { mainMenu: 'add-ancilliaries-screen' };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    }
  }

  selectedPassengerForSplitBooking(passengerIndex: number, event: boolean) {
    if (event) {
      this.passengerDetailScreenData.passengerBList!.push(passengerIndex);
      this.passengerDetailScreenData.passengerBList!.sort();
    } else {
      const position = this.passengerDetailScreenData.passengerBList!.findIndex((passengerB) => passengerB === passengerIndex);
      if (position > -1) {
        this.passengerDetailScreenData.passengerBList!.splice(position, 1);
      }
    }
    this.updatePassengerDetailsInSandboxState();
  }

  updatePassengerDetailsInSandboxState() {
    this.sandboxPageStateService.updatePassengerDetailScreenData(this.passengerDetailScreenData);
  }

  roundPassengerDetailsPrice(value: string): string {
    let priceData = parseFloat(value);
    return priceData.toFixed(2);
  }

  updateAddBaggageScreenXML(url: string, passengerIndex: any) {
    let patchSandboxSourceData: any = {};
    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      patchSandboxSourceData = { showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      let warningMessage = this.sandboxPageStateService.getWarningMessage();
      if (warningMessage !== '') {
        patchSandboxSourceData['showWarning'] = 'Yes';
        patchSandboxSourceData['warningMessage'] = this.sandboxPageStateService.getWarningMessage();
      }
      let selectedPassengerDetail = this.passengerDetailScreenData.passengerDetail[passengerIndex];
      let addBaggageScreen: AddBaggageScreen = {} as AddBaggageScreen;
      addBaggageScreen.xml = this.sandboxPageStateService.getResponseFromMap(url);
      addBaggageScreen.jsonData = this.xmlToJsonParserService.parseXMLToJSON(addBaggageScreen.xml);

      let addBaggageScreenJSONData = addBaggageScreen.jsonData;
      let seatEnvelope = addBaggageScreenJSONData['SOAP:ENVELOPE'];
      let seatBody = seatEnvelope['SOAP:BODY'][0];
      let searviceListReponse = seatBody.SERVICELISTRS[0];
      if (typeof searviceListReponse.ALACARTEOFFER !== 'undefined') {
        patchSandboxSourceData['mainMenu'] = 'add-baggage';
        addBaggageScreen.bookingType = 'offer-price-screen-add-service';
        addBaggageScreen.serviceType = 'BAG';
        addBaggageScreen.passengerIndex = passengerIndex;
        addBaggageScreen.passengerId = selectedPassengerDetail.passengerId;
        addBaggageScreen.passengerName = selectedPassengerDetail.passengerName + ' ' + selectedPassengerDetail.passengerSurName;
        addBaggageScreen.boundBaggageList = [];
        this.sandboxPageStateService.updateAddBaggageScreenDetail(addBaggageScreen);
      }
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    }
  }

  async addPrimeBookingBaggage(passengerIndex: any) {
    let offerPriceScreenDetail = this.sandboxPageStateService.getOfferPriceScreenData();
    let responseId = offerPriceScreenDetail.offerPrice.responseId;
    let owner = offerPriceScreenDetail.offerPrice.owner;
    let offerId = offerPriceScreenDetail.offerPrice.offerId;
    let selectedOfferItem = offerPriceScreenDetail.selectedOfferItem;
    const jsonRequest = this.sandboxPageStateService.getJsonRequestFromMap(this.sandboxPageStateService.AIRLINE_OFFERS_SCREEN_URL);
    const airlineOffersScreenRequest: AirlineOffersScreenRequest = JSON.parse(jsonRequest);
    let jsonRequestTemplate = await this.localAssetReaderService.getContent(this.sandboxPageStateService.PRIME_BAG_SERVICE_REQUEST_TEMPLATE);
    this.offerPriceScreenServiceListRequest = JSON.parse(jsonRequestTemplate as any);
    this.offerPriceScreenServiceListRequest['S:Envelope'].$!['xmlns:S'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.offerPriceScreenServiceListRequest['S:Envelope'].$!['xmlns:SOAP-ENV'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.offerPriceScreenServiceListRequest['S:Envelope']['SOAP-ENV:Header'] = '';
    this.offerPriceScreenServiceListRequest['S:Envelope']['S:Body']!.ServiceListRQ = {
      $: {
        'xmlns:xsd': 'http://www.w3.org/2001/XMLSchema',
        'xmlns:xsi': 'http://www.w3.org/2001/XMLSchema-instance',
        xmlns: 'http://www.iata.org/IATA/EDIST/2017.2',
        Version: '17.2'
      },
      Document: airlineOffersScreenRequest['S:Envelope']['S:Body']?.OfferPriceRQ.Document,
      Party: airlineOffersScreenRequest['S:Envelope']['S:Body']?.OfferPriceRQ.Party,
      ShoppingResponseID: {
        ResponseID: responseId
      },
      Query: {
        Offers: {
          Offer: {
            OfferID: {
              $: {
                Owner: owner
              },
              _: offerId
            },
            OfferItemIDs: {
              OfferItemID: this.loadOfferDetail(selectedOfferItem, owner)
            }
          }
        }
      },
      DataLists: {
        PassengerList: {
          Passenger: this.loadPassenger(this.passengerDetailScreenData.passengerDetail)
        }
      }
    };
    await this.apiService.getXMLResponse(this.sandboxPageStateService.OFFER_PRICE_SCREEN_SERVICE_LIST_URL, JSON.stringify(this.offerPriceScreenServiceListRequest), new Map(), {
      headers: new HttpHeaders({
        soapAction: 'ServiceList17_2_V1'
      }),
      responseType: 'text'
    });

    this.updateAddBaggageScreenXML(this.sandboxPageStateService.OFFER_PRICE_SCREEN_SERVICE_LIST_URL, passengerIndex);
  }
  loadOfferDetail(offerItemsList: OfferItems[], owner: any) {
    let offerItems: OfferItemID[] = [];
    offerItemsList.forEach((offer: OfferItems) => {
      let offerItem = {} as OfferItemID;
      offerItem._ = offer.offerItemID;
      offerItem.$ = {} as OfferItemIDAttributes;
      offerItem.$.Owner = owner;
      offerItems.push(offerItem);
    });
    return offerItems;
  }
  loadPassenger(passengerList: Passenger[]) {
    let passengersDetail: primeSalePassenger[] = [];
    passengerList.forEach((passenger: Passenger) => {
      let passengerDetail: primeSalePassenger = {
        $: {
          PassengerID: passenger.passengerId
        },
        PTC: passenger.passengerType,
        Birthdate: passenger.passengerDOB,
        ResidenceCountryCode: this.sandboxPageStateService.getAgentResidenceCountryCode(),
        CitizenshipCountryCode: this.sandboxPageStateService.getCitizenshipCountryCode()
      };
      if (passenger.infantRef !== 'undefined' && passenger.passengerType === 'ADT') {
        passengerDetail.InfantRef = passenger.infantRef;
      }
      passengersDetail.push(passengerDetail);
    });

    return passengersDetail;
  }

  addPassengerDetails(passengerIndex: any) {
    let passengerDetailScreen = this.sandboxPageStateService.getPassengerScreenDetail();
    passengerDetailScreen.activePassengerIndex = passengerIndex;
    this.sandboxPageStateService.updatePassengerDetailScreenData(passengerDetailScreen);
    let patchSandboxSourceData = { mainMenu: 'passenger-details', sideMenu: 'none' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }
  removeServiceFromPassenger(type: 'MEAL' | 'BAG' | 'DisabilityAssistance' | 'CARB', passengerIndex: any, serviceIndex: any) {
    let selectedOfferItemId: any = '';
    let selectedPassengerId: any = '';
    if (type === 'BAG') {
      selectedOfferItemId = this.passengerDetailScreenData.passengerDetail[passengerIndex].passengerOtherDetails.passengerSelectedBaggageDetail[serviceIndex].baggageName;
      selectedPassengerId = this.passengerDetailScreenData.passengerDetail[passengerIndex].passengerId;
      this.passengerDetailScreenData.passengerDetail[passengerIndex].passengerOtherDetails.passengerSelectedBaggageDetail.splice(serviceIndex, 1);
    } else if (type === 'MEAL') {
      selectedOfferItemId = this.passengerDetailScreenData.passengerDetail[passengerIndex].passengerOtherDetails.passengerSelectedMealDetails[serviceIndex].baggageName;
      this.passengerDetailScreenData.passengerDetail[passengerIndex].passengerOtherDetails.passengerSelectedMealDetails.splice(serviceIndex, 1);
    } else if (type === 'DisabilityAssistance') {
      selectedOfferItemId = this.passengerDetailScreenData.passengerDetail[passengerIndex].passengerOtherDetails.passengerSelectedDisablityServiceDetail[serviceIndex].baggageName;
      this.passengerDetailScreenData.passengerDetail[passengerIndex].passengerOtherDetails.passengerSelectedDisablityServiceDetail.splice(serviceIndex, 1);
    } else if (type === 'CARB') {
      selectedOfferItemId = this.passengerDetailScreenData.passengerDetail[passengerIndex].passengerOtherDetails.passengerSelectedProductClimateServiceDetail[serviceIndex].baggageName;
      this.passengerDetailScreenData.passengerDetail[passengerIndex].passengerOtherDetails.passengerSelectedProductClimateServiceDetail.splice(serviceIndex, 1);
    }
    this.sandboxPageStateService.updatePassengerDetailScreenData(this.passengerDetailScreenData);
    let addAncilliariesScreenData = this.sandboxPageStateService.getAddAncilliariesScreenData();
    let selectedOffers = addAncilliariesScreenData.selectedOfferItem;
    let selectedOfferLength = selectedOffers.length;
    if (selectedOfferLength > 0) {
      selectedOffers.forEach((selectedOffer: addAncilliariesOfferItem, selectedOfferItemIndex) => {
        if (selectedOffer.offerItemID === selectedOfferItemId && selectedOffer.passengerId === selectedPassengerId) {
          addAncilliariesScreenData.selectedOfferItem.splice(selectedOfferItemIndex, 1);
          addAncilliariesScreenData.selectedOfferItem = addAncilliariesScreenData.selectedOfferItem;
        }
      });
    }
    let selectedOfferItemLength = addAncilliariesScreenData.selectedOfferItem.length;
    if (selectedOfferItemLength === 0) {
      addAncilliariesScreenData.displayService = 'All';
    }
    this.sandboxPageStateService.updateAddAncilliariesScreenData(addAncilliariesScreenData);
  }
  deleteService(type: 'MEAL' | 'BAG' | 'DisabilityAssistance' | 'CARB', passengerIndex: any, serviceIndex: any) {
    this.selectedPassengerIndex = passengerIndex;
    this.selectedServiceIndex = serviceIndex;
    this.selectedServiceType = type;
  }
  confirmDeleteService() {
    this.initDeleteSeatOrderChangeRequest();
  }
  async initDeleteSeatOrderChangeRequest() {
    let yourBookingScreenDetail = this.sandboxPageStateService.getYourBookingScreenData();
    let bookingDetail = yourBookingScreenDetail.booking;
    let pnr = bookingDetail?.pnrNumber;
    let jsonRequestTemplate = await this.localAssetReaderService.getContent(this.sandboxPageStateService.ORDERCHANGE_ISSUE_TICKET_REQUEST_TEMPLATE);
    this.orderChangeRemoveService = JSON.parse(jsonRequestTemplate as any);
    this.orderChangeRemoveService['S:Envelope'].$['xmlns:S'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.orderChangeRemoveService['S:Envelope'].$['xmlns:SOAP-ENV'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.orderChangeRemoveService['S:Envelope']['SOAP-ENV:Header'] = '';
    this.orderChangeRemoveService['S:Envelope']['S:Body']!.OrderChangeRQ.$['xmlns:xsd'] = 'http://www.w3.org/2001/XMLSchema';
    this.orderChangeRemoveService['S:Envelope']['S:Body']!.OrderChangeRQ.$['xmlns:xsi'] = 'http://www.w3.org/2001/XMLSchema-instance';
    this.orderChangeRemoveService['S:Envelope']['S:Body']!.OrderChangeRQ.$.xmlns = 'http://www.iata.org/IATA/EDIST/2017.2';
    this.orderChangeRemoveService['S:Envelope']['S:Body']!.OrderChangeRQ.$.Version = '17.2';
    this.orderChangeRemoveService['S:Envelope']['S:Body'].OrderChangeRQ.DataLists.PassengerList.Passenger = [];
    this.orderChangeRemoveService['S:Envelope']['S:Body'].OrderChangeRQ.Query.OrderID = pnr;
    if (this.selectedServiceType === 'MEAL') {
      this.orderChangeRemoveService['S:Envelope']['S:Body'].OrderChangeRQ.Query.OrderServicing = {
        Delete: {
          OrderItemID: this.loadMealDetail()
        }
      };
    }
    if (this.selectedServiceType === 'BAG') {
      this.orderChangeRemoveService['S:Envelope']['S:Body'].OrderChangeRQ.Query.OrderServicing = {
        Delete: {
          OrderItemID: this.loadBagDetail()
        }
      };
    }
    if (this.selectedServiceType === 'CARB') {
      this.orderChangeRemoveService['S:Envelope']['S:Body'].OrderChangeRQ.Query.OrderServicing = {
        Delete: {
          OrderItemID: this.loadProductClimateDetail()
        }
      };
    }
    if (this.selectedServiceType === 'DisabilityAssistance') {
      this.orderChangeRemoveService['S:Envelope']['S:Body'].OrderChangeRQ.Query.OrderServicing = {
        Delete: {
          OrderItemID: this.loadDisabilityDetail()
        }
      };
    }
    delete this.orderChangeRemoveService['S:Envelope']['S:Body'].OrderChangeRQ.Query.AcceptRepricedOrder;
    delete this.orderChangeRemoveService['S:Envelope']['S:Body'].OrderChangeRQ.DataLists.ContactList;
    delete this.orderChangeRemoveService['S:Envelope']['S:Body'].OrderChangeRQ.Query.Payments;
    this.loadOrderChangePassengerDetail();
    await this.apiService.getXMLResponse(this.sandboxPageStateService.ORDER_CHANGE_URL, JSON.stringify(this.orderChangeRemoveService), this.orderChangeInputParams, {
      headers: new HttpHeaders({
        soapAction: 'OrderChange17_2_V4'
      }),
      responseType: 'text'
    });
    this.updateRemoveServcieResponseXML(this.sandboxPageStateService.ORDER_CHANGE_URL);
  }
  updateRemoveServcieResponseXML(url: any) {
    let orderChangeXMLData = this.sandboxPageStateService.getResponseFromMap(url);
    let orderChangeJSONData = this.xmlToJsonParserService.parseXMLToJSON(orderChangeXMLData);
    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      let patchSandboxSourceData = { showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      let yourBookingScreenData = this.sandboxPageStateService.getYourBookingScreenData();
      yourBookingScreenData.xml = orderChangeXMLData;
      yourBookingScreenData.jsonData = orderChangeJSONData;
      yourBookingScreenData.isMapped = false;
      this.sandboxPageStateService.updateYourBookingScreenData(yourBookingScreenData);

      let patchSandboxSourceData: any = { mainMenu: 'none' };
      if (this.sandboxPageStateService.getWarningMessage() !== '') {
        patchSandboxSourceData['showWarning'] = 'Yes';
        patchSandboxSourceData['warningMessage'] = this.sandboxPageStateService.getWarningMessage();
      }
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
      setTimeout(() => {
        let patchSandboxSourceData: any = '';
        patchSandboxSourceData = { mainMenu: 'your-booking-screen' };
        this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
      }, 200);
    }
  }
  loadOrderChangePassengerDetail() {
    let passengerDetailScreenData = this.sandboxPageStateService.getPassengerDetailScreenData();
    let passengerDetail = passengerDetailScreenData.passengerDetail;
    let passengerDetails: orderChangePassenger[] = [];

    let passengerDetailLength: any = passengerDetail.length;
    if (passengerDetailLength > 0) {
      passengerDetail.forEach((passenger: Passenger) => {
        let passengerId = passenger.passengerId;
        let passengerDetail = {} as orderChangePassenger;
        passengerDetail.$ = {
          PassengerID: passengerId
        };
        passengerDetail.PTC = passenger.passengerType;
        passengerDetail.Birthdate = passenger.passengerDOB;
        passengerDetail.Individual = {
          Gender: passenger.passengerGender,
          NameTitle: this.capitalizeFirstLetter(passenger.passengerNameTitle),
          GivenName: passenger.passengerName,
          Surname: passenger.passengerSurName
        };
        passengerDetails.push(passengerDetail);
      });
      this.orderChangeRemoveService['S:Envelope']['S:Body'].OrderChangeRQ.DataLists.PassengerList.Passenger = passengerDetails;
    }
  }
  capitalizeFirstLetter(words: any) {
    const result = words.charAt(0).toUpperCase() + words.slice(1).toLowerCase();
    return result;
  }
  loadMealDetail() {
    let passengerScreenData = this.sandboxPageStateService.getPassengerDetailScreenData();
    let offerDetail = passengerScreenData.passengerDetail[this.selectedPassengerIndex].passengerOtherDetails.passengerMealDetails[this.selectedServiceIndex];
    let OrderItemIDs: any[] = [];
    OrderItemIDs.push(offerDetail.offerItemId);
    return OrderItemIDs;
  }
  loadBagDetail() {
    let passengerScreenData = this.sandboxPageStateService.getPassengerDetailScreenData();
    let offerDetail = passengerScreenData.passengerDetail[this.selectedPassengerIndex].passengerOtherDetails.passengerBaggageDetails[this.selectedServiceIndex];
    let OrderItemIDs: any[] = [];
    OrderItemIDs.push(offerDetail.offerItemId);
    return OrderItemIDs;
  }
  loadProductClimateDetail() {
    let passengerScreenData = this.sandboxPageStateService.getPassengerDetailScreenData();
    let offerDetail = passengerScreenData.passengerDetail[this.selectedPassengerIndex].passengerOtherDetails.passengerProductClimateServiceDetail[this.selectedServiceIndex];
    let OrderItemIDs: any[] = [];
    OrderItemIDs.push(offerDetail.offerItemId);
    return OrderItemIDs;
  }
  loadDisabilityDetail() {
    let passengerScreenData = this.sandboxPageStateService.getPassengerDetailScreenData();
    let offerDetail = passengerScreenData.passengerDetail[this.selectedPassengerIndex].passengerOtherDetails.passengerDisablityServiceDetail[this.selectedServiceIndex];
    let OrderItemIDs: any[] = [];
    OrderItemIDs.push(offerDetail.offerItemId);
    return OrderItemIDs;
  }
}
